import { currentUserQuery } from "@common/api/users"
import { Card } from "@common/components/ui/card"
import { hasPermission } from "@common/lib/permissions"
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { CustomerForm } from "@/routes/_layout/customer/-components/form/customer-form"

export const Route = createFileRoute("/_layout/customer_/new")({
  staticData: {
    breadcrumb: [
      { label: "Customers", href: "/customer" },
      { label: "New customer" },
    ],
  },
  beforeLoad: async ({ context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(currentUserQuery())
    if (!hasPermission(me, "customer:create")) {
      throw redirect({ to: "/customer" })
    }
  },
  component: CreateCustomerPage,
})

function CreateCustomerPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()

  return (
    <div className="h-full overflow-y-auto">
      <PageContent>
        <PageTitle title="New customer" />
        <Card className="p-4 shadow-none">
          <CustomerForm
            onCreate={(created) => {
              showToast(
                "Created",
                `${created.name || "Customer"} added.`,
                "success",
              )
              navigate({
                to: "/customer/$customerId",
                params: { customerId: created.id },
              })
            }}
          />
        </Card>
      </PageContent>
    </div>
  )
}
